import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungRostock() {
  return (
    <CityPageTemplate
      city="Rostock"
      slug="rostock"
      intro="In der Hafenstadt Rostock an der Ostsee beraten wir Dich 100% digital und unabhängig."
      description="Unabhängige & digitale Finanzberatung für Rostock: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
